/*
 * @copyright Copyright (c) valantic CEC Deutschland GmbH (https://www.valantic.com)
 * @see PROJECT_LICENSE.txt
 */

import { mapGtmItem } from '../../api/mapping'

const liveSearchDataLayer = {
    /**
     * Dispatch custom event with data layer items
     *
     * @param items
     */
    dataLayerPushItems(items) {
        window.dispatchEvent(new CustomEvent('liveSearchProductsLoaded', {
            detail: {
                items: items.map(item => item.gtmItem || mapGtmItem(item))
            }
        }))
    },
    /**
     * Push select_item for PLP/search result clicks.
     *
     * @param {HTMLElement|null} productItem
     */
    dataLayerPushSelectItem(productItem) {
        if (!productItem?.dataset?.gtmItem || typeof window?.dataLayer?.push !== 'function') {
            return
        }

        try {
            const gtmItem = JSON.parse(productItem.dataset.gtmItem)

            if (!gtmItem || Object.keys(gtmItem).length === 0) {
                return
            }

            const gtmData = {
                event: 'select_item',
                ecommerce: {
                    item_list_id: window?.localStorage?.lastPageType || '',
                    item_list_name: window?.localStorage?.lastPageType || '',
                    item_list_path: window?.localStorage?.lastCategoryPath || '',
                    items: [gtmItem]
                }
            }

            if (typeof window?.yireoGoogleTagManager2Logger === 'function') {
                window.yireoGoogleTagManager2Logger('page event "select_item" (catalogSearch)', gtmData)
            }

            window.dataLayer.push(gtmData)
        } catch (error) {
            console.error('select_item tracking failed:', error)
        }
    }
}

export default liveSearchDataLayer
